import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ResequenceFinalPreview.module.css';
import moment from 'moment';
import ResequencingToolbar from '../ResequencingToolbar/ResequencingToolbar';
import { optionalColumns, OPTIONAL_ATTRIBUTES } from '../../staticData';
import { SequenceTable } from '../../atomicComponents';

const ResequenceFinalPreview = ({
  lineName,
  handleConfirm,
  date,
  sourceData,
  handleBack,
}) => {
  const [selectedOptionalColNames, setSelectedOptionalColNames] = useState([
    OPTIONAL_ATTRIBUTES.FAMILY,
    OPTIONAL_ATTRIBUTES.BUILD_CARD_NUMBER,
    OPTIONAL_ATTRIBUTES.FBV_VENDOR_NAME,
    OPTIONAL_ATTRIBUTES.POWER_STEERING,
    OPTIONAL_ATTRIBUTES.COUNTRY,
    OPTIONAL_ATTRIBUTES.MARKET,
  ]);
  const [rows, setRows] = useState([...sourceData]);

  const handleDragEnd = result => {
    if (!result.destination) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }

    setRows(prev => {
      const [removed] = prev.splice(result.source.index, 1);
      prev.splice(result.destination.index, 0, removed);

      return [...prev];
    });
  };

  return (
    <>
      <div style={{ height: '8%' }}>
        <ResequencingToolbar
          selectedOptionalColNames={selectedOptionalColNames}
          handleColumnSelection={selection =>
            setSelectedOptionalColNames(selection)
          }
          lineName={lineName}
          date={date}
          optionalColumns={optionalColumns}
          submitButtonText={'Confirm'}
          cancelButtonText={'Back'}
          handleCancel={handleBack}
          handleSubmit={e => {
            if (e.detail > 1) {
              console.log('A double-click has been registered');
              return;
            }
            return handleConfirm(rows);
          }}
          isDragAndDropEnabled={true}
        />
      </div>
      <div className={styles.tableContainer}>
        <SequenceTable
          showRowNumbers
          enableDragAndDrop
          sourceRows={rows}
          selectedOptionalColNames={selectedOptionalColNames}
          maxEmptyRowPadding={0}
          rowHeight={36}
          headerRowHeight={38}
          handleDragEnd={handleDragEnd}
        />
      </div>
    </>
  );
};

ResequenceFinalPreview.propTypes = {
  date: PropTypes.objectOf(moment),
  sourceData: PropTypes.arrayOf(
    PropTypes.shape({
      vc: PropTypes.any.isRequired,
      description: PropTypes.any,
      serialNumber: PropTypes.number.isRequired,
      id: PropTypes.any.isRequired,
    }),
  ),
  lineName: PropTypes.string.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

export default ResequenceFinalPreview;
